class Parameters {
    constructor() {
    }


    plan_refine_tag = [
        { type: 0, name: '新訂單' },
        { type: 1, name: 'ReFine' },
        { type: 2, name: '維持器' },
        { type: 3, name: '假牙' },
        { type: 5, name: 'aligner-plan' },
        { type: 6, name: 'aligner-維持器' },
    ]

    getPlanRefineTag(type) {
        if (type === -1) {
            return this.plan_refine_tag;
        }
        const refine_tag = this.plan_refine_tag.find(refine_tag => refine_tag.type === Number(type));
        return refine_tag ? refine_tag.name : '?';
    }

    plan_refine_tag_icon = [
        { type: 0, icon: 'fa-file' },
        { type: 1, icon: 'fa-reply-all' },
        { type: 2, icon: 'fa-teeth' },
        { type: 3, icon: 'fa-tooth' },
        { type: 5, icon: 'fa-reply-all' },
        { type: 6, icon: 'fa-teeth' },
    ]

    getPlanRefineTagIcon(type) {
        if (type === -1) {
            return this.plan_refine_tag_icon;
        }
        const refine_icon = this.plan_refine_tag_icon.find(refine_tag => refine_tag.type === Number(type));
        return refine_icon ? refine_icon.icon : 'fa-file';
    }



    plan_oralType = [
        { type: 0, name: '全口' },
        { type: 1, name: '上顎' },
        { type: 2, name: '下顎' }
    ]

    getPlanOralType(type) {
        if (type === -1) {
            return this.plan_oralType;
        }

        const oralType = this.plan_oralType.find(oralType => oralType.type === type);
        return oralType ? oralType.name : '?';
    }

    aligner_sp = {
        aligner_sp_item_1: '簍空',
        aligner_sp_item_2: '虛擬牙',
        aligner_sp_item_3: '拋光',
        aligner_sp_item_4: '補倒凹',
        aligner_sp_item_5: '剪cut',
        aligner_sp_item_6: '車波浪',
        aligner_sp_item_7: '牙齦上',
        aligner_sp_item_8: '牙齦下',
        aligner_sp_item_9: '其他',
        aligner_sp_item_10: '設計代工',
        aligner_sp_item_11: '雷射',
        aligner_sp_item_12: '戳洞',
        aligner_sp_item_13: '三層料',
        aligner_sp_item_correction_up: "加修上顎矯正器",
        aligner_sp_item_correction_lowe: "加修下顎矯正器",

    }

    appointmentPlanDate = [{
        tag: 0,
        days: [{
            isCheckReport: false,
            minDayValue: 10
        }, {
            isCheckReport: true,
            minDayValue: 7
        }]
    }, {
        tag: 1,
        days: [{
            isCheckReport: false,
            minDayValue: 10
        }, {
            isCheckReport: true,
            minDayValue: 7
        }]
    }, {
        tag: 2,
        days: [
            { minDayValue: 4 }
        ]
    }, {
        tag: 5,
        days: [
            { minDayValue: 4 }
        ]
    }, {
        tag: 6,
        days: [
            { minDayValue: 4 }
        ]
    }]

    appointmentStepDate = [{
        tag: 0,
        minDayValue: 7
    }, {
        tag: 1,
        minDayValue: 7
    }, {
        tag: 2,
        minDayValue: 4
    }, {
        tag: 5,
        minDayValue: 4
    }, {
        tag: 6,
        minDayValue: 4
    }]


}
export default Parameters